import { addNamespaceInOperations } from '../helper'

export const GETTERS_METHODS = {
  GET_CONNECTIONS: 'getConnections',
  GET_VIEW: 'getView',
  GET_ALL_VIEWS: 'getViews',
  GET_JAVASCRIPT: 'getJavascript',
  GET_STYLE: 'getStyle',
  GET_AVAILABLE_COMPONENTS: 'getAvailableComponents'
}

export const getters = {
  [GETTERS_METHODS.GET_AVAILABLE_COMPONENTS]: (state) => () => {
    return state.availableComponents
  },
  [GETTERS_METHODS.GET_STYLE]: (state) => () => {
    return state.style
  },
  [GETTERS_METHODS.GET_JAVASCRIPT]: (state) => () => {
    return state.javascript
  },
  [GETTERS_METHODS.GET_CONNECTIONS]: (state) => () => {
    return state.connections
  },
  [GETTERS_METHODS.GET_VIEW]: (state) => (id) => {
    return state.views[id]
  },
  [GETTERS_METHODS.GET_ALL_VIEWS]: (state) => () => {
    return Object.keys(state.views)
  }
}

export const GETTERS = addNamespaceInOperations('design', GETTERS_METHODS)
